import React, { Component } from 'react';
import Link from 'gatsby-link';
import mui, { Grid, List, ListItemIcon } from '@material-ui/core/';
import Typography from '@material-ui/core/Typography';
import logoImage from '../../images/logo.png';
import styled from '../../utils/styled';
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import CookieConsent from 'react-cookie-consent';
import { FaFacebookSquare, FaInstagram, FaMailBulk } from 'react-icons/fa';

const FooterWrapper = styled(Grid, {
  component: 'footer',
  container: true,
  spacing: 8,
  fontSize: '0.75em',
})(theme => ({
  background: theme.palette.background.default,
  padding: `${theme.spacing.unit * 2}px 0`,
  '& a:link, & a:visited': {
    cursor: 'pointer',
    color: 'inherit',
    textDecoration: 'none',
  },
  '& a:hover, & a:active': {
    cursor: 'pointer',
    color: 'inherit',
    textDecoration: 'underline',
  },
}));

const Left = styled(Grid)(theme => ({
    textAlign: 'right',
}));

const Middle = styled(Grid)(theme => ({
  textAlign: 'center',
}));

const Right = styled(Grid)(theme => ({
  textAlign: 'left',
}));

const FooterLink = styled(Link)(theme => ({
  display: 'inline-block',
}));

const Caption = styled(Typography, { variant: 'caption' })(theme => ({
  display: 'block',
}));

const SocialList = styled(List)(theme => ({
    display: 'inline-block',
    listStyleType: 'none',
    justifyContent: 'center',
    margin: 0,
    padding: 0,
}))

class Footer extends Component {

  render() {
    const { data: { site } } = this.props;
    return (
      <FooterWrapper>
        <Left id="leftGroup" item xs={12} sm={5}>
            <Caption>
              <FooterLink to="/contact">
                <Typography variant="caption">Kontaktid</Typography>
              </FooterLink>
            </Caption>
        </Left>

        <Middle id="socialGroup" item xs={12} sm={2}>

<SocialList id="socialList">

 <OutboundLink
    title="Seikluseksperdid Facebook"
    href={site.siteMetadata.facebookUrl}
    target="_blank"
     rel="noopener noreferrer"
 >
<FaFacebookSquare />
</OutboundLink>

<OutboundLink
title="Seikluseksperdid Instagram"
href={site.siteMetadata.instagramUrl}
target="_blank"
rel="noopener noreferrer"
>
<FaInstagram />
</OutboundLink>

<a title="Seikluseksperdid e-post" href={`mailto:${site.siteMetadata.email}`}>
<FaMailBulk />
</a>


        </SocialList>

        </Middle>

        <Right id="rightGroup" item xs={12} sm={2}>
            <Caption>
              <FooterLink to="/privacy-policy">
                <Typography variant="caption">Privaatsuspoliitika</Typography>
              </FooterLink>
              {` | `}
              <FooterLink to="/selling-terms">
                <Typography variant="caption">Üldtingimused</Typography>
              </FooterLink>
            </Caption>
        </Right>

        <Left id="left" item xs={12} sm={5}/>
        <Middle item xs={12} sm={2}>
            <Typography variant="caption">Elu on seiklust väärt!</Typography>
        </Middle>
        <Right item xs={12} sm={5}></Right>
        <CookieConsent
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={15}
          buttonText="Sain aru">
          <Typography  variant="body2" color="secondary">
          Sellel leheküljel kasutatakse küpsiseid, et tagada turvalisus ja kasutajamugavus.
          Vajuatdes nupul 'Sain aru' kinnitate, et olete tutvunud ja aru saanud <Link to="/privacy-policy"><u>Privaatsuspoliitikaga</u> </Link>
          ja <Link to="/selling-terms"><u>Üldtingimustega</u></Link>
          </Typography>



        </CookieConsent>
      </FooterWrapper>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js